<template>
  <page>
    <div>
                <message :messages="messages"></message>
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div><v-icon>mdi-filter-variant</v-icon>Filters</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex xs12 md6>
                              <v-text-field
                                v-model="filters.acctNo"
                                :label="labels.acctNo"
                                :error-messages="errors.collect('filters.acctNo')"
                                data-vv-name="filters.acctNo"
                                :data-vv-as="labels.acctNo"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="doHelpList('filters', 'inter')">mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 md6>
                              <v-text-field
                                v-model="filters.branch"
                                :label="labels.branch"
                                :error-messages="errors.collect('filters.branch')"
                                data-vv-name="filters.branch"
                                :data-vv-as="labels.branch"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="doHelpList('filters', 'branch')">mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 md6>
                              <v-text-field
                                v-model="filters.tranType"
                                :label="labels.tranType"
                                :error-messages="errors.collect('filters.tranType')"
                                data-vv-name="filters.tranType"
                                :data-vv-as="labels.tranType"
                              >
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 md6>
                              <v-text-field
                                v-model="filters.docNo"
                                :label="labels.docNo"
                                :error-messages="errors.collect('filters.docNo')"
                                data-vv-name="filters.docNo"
                                :data-vv-as="labels.docNo"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="doHelpList('filters', 'docNo')">mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 md6>
                              <v-text-field
                                v-model="filters.fund"
                                :label="labels.fund"
                                :error-messages="errors.collect('filters.fund')"
                                data-vv-name="filters.fund"
                                :data-vv-as="labels.fund"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="doHelpList('filters', 'fund')">mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 md6>
                              <v-text-field
                                v-model="filters.acctNoSfx"
                                :label="labels.acctNoSfx"
                                :error-messages="errors.collect('filters.acctNoSfx')"
                                data-vv-name="filters.acctNoSfx"
                                :data-vv-as="labels.acctNoSfx"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="doHelpList('filters', 'acctNoSfx')">mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                        <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-container fluid grid-list-lg>
                  <v-card>
                    <v-card-actions>
                      <v-flex xm9></v-flex>
                      <v-btn class="mr-2" color="primary" dark @click.prevent="doAdd()">
                        New Record
                        <v-icon dark right>mdi-plus</v-icon>
                      </v-btn>
                    </v-card-actions>
                    <v-data-table
                      :headers="headers"
                      :items="items"
                      :loading="loading"
                      :options.sync="pagination"
                      :server-items-length="totalItems"
                      :footer-props="{ 'items-per-page-options': itemsPerPage }"
                      :no-data-text="noDataText"
                    >
                      <template v-slot:item="row">
                        <tr>
                          <td>{{ row.item.acctNo }}</td>
                          <td>{{ row.item.branch }}</td>
                          <td>{{ row.item.tranType }}</td>
                          <td>{{ row.item.docNo }}</td>
                          <td>{{ row.item.fund }}</td>
                          <td>{{ row.item.acctNoSfx }}</td>
                          <td class="table-action-header">
                            <table-action :rowData="row" remove @remove="doPromptRemove(row.item)"></table-action>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-container>
              <v-spacer class="mt-3"></v-spacer>
                <v-btn :loading="loading" color="error" dark @click.prevent="doCancel"
                  >{{ labels.cancel }}<v-icon dark right>mdi-cancel</v-icon></v-btn
                >
    </div>

    <v-dialog v-model="showAddRecord" width="1000px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-toolbar-title>Exclude This Transaction</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  :label="labels.acctNo"
                  v-model="form.acctNo"
                  data-vv-name="acctNo"
                  :data-vv-as="labels.acctNo"
                  :error-messages="errors.collect('acctNo')"
                  v-validate="'required'"
                  clearable
                  ><v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="doHelpList('form', 'inter')">mdi-magnify</v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :label="labels.branch"
                  v-model="form.branch"
                  item-text="label"
                  item-value="value"
                  data-vv-name="branch"
                  :data-vv-as="labels.branch"
                  :error-messages="errors.collect('branch')"
                  v-validate="branchValidation()"
                  clearable
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="doHelpList('form', 'branch')">mdi-magnify</v-icon>
                  </v-slide-x-reverse-transition></v-text-field
                >
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :label="labels.tranType"
                  v-model="form.tranType"
                  item-text="label"
                  item-value="value"
                  data-vv-name="tranType"
                  :data-vv-as="labels.tranType"
                  :error-messages="errors.collect('tranType')"
                  v-validate="tranTypeValidation()"
                  clearable
                >
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :label="labels.docNo"
                  v-model="form.docNo"
                  item-text="label"
                  item-value="value"
                  data-vv-name="docNo"
                  :data-vv-as="labels.docNo"
                  :error-messages="errors.collect('docNo')"
                  v-validate="docNoValidation()"
                  clearable
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="doHelpList('form', 'docNo')">mdi-magnify</v-icon>
                  </v-slide-x-reverse-transition></v-text-field
                >
              </v-flex>
              <v-flex xs6 md6 lg6>
                <v-text-field
                  :label="labels.fund"
                  v-model="form.fund"
                  item-text="label"
                  item-value="value"
                  data-vv-name="fund"
                  :data-vv-as="labels.fund"
                  :error-messages="errors.collect('fund')"
                  v-validate="fundValidation()"
                  clearable
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="doHelpList('form', 'fund')">mdi-magnify</v-icon>
                  </v-slide-x-reverse-transition></v-text-field
                >
              </v-flex>
              <v-flex xs6 md6 lg6>
                <v-text-field
                  :label="labels.acctNoSfx"
                  v-model="form.acctNoSfx"
                  item-text="label"
                  item-value="value"
                  data-vv-name="acctNoSfx"
                  :data-vv-as="labels.acctNoSfx"
                  :error-messages="errors.collect('acctNoSfx')"
                  v-validate="acctNoSfxValidation()"
                  clearable
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="doHelpList('form', 'acctNoSfx')">mdi-magnify</v-icon>
                  </v-slide-x-reverse-transition></v-text-field
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="info darken-1" @click.native="doReset">Reset</v-btn>
          <v-btn text color="red darken-1" @click.native=";(showAddRecord = false), resetMessages()">Cancel</v-btn>
          <v-btn text color="primary" @click.native="doSave" :loading="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showInterHelpList" width="900px" persistent>
      <intermediary-help-list
        :interGrps="'10,11,20,25'"
        @close="showInterHelpList = false"
        @assign-intermediary="doAssign('inter', $event)"
      ></intermediary-help-list>
    </v-dialog>

    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <branch-help-list @close="showBranchHelpList = false" @assign-branch="doAssign('branch', $event)"></branch-help-list>
    </v-dialog>

    <v-dialog v-model="showTranTypeHelpList" width="900px" persistent>
      <tranType-help-list2 @close="showTranTypeHelpList = false" @assign-tranType="doAssign('tranType', $event)"></tranType-help-list2>
    </v-dialog>

    <v-dialog v-model="showDocNoHelpList" width="900px" persistent>
      <docNo-help-list
        v-if="showDocNoHelpList"
        :accountNo="helpListFilterType === 'filters' ? filters.acctNo : form.acctNo"
        :branch="helpListFilterType === 'filters' ? filters.branch : form.branch"
        :tranType="helpListFilterType === 'filters' ? filters.tranType : form.tranType"
        :fund="helpListFilterType === 'filters' ? filters.fund : form.fund"
        :acctNoSfx="helpListFilterType === 'filters' ? filters.acctNoSfx : form.acctNoSfx"
        :fromExclGsttran="true"
        @close="showDocNoHelpList = false"
        @assign-doc-no-info="doAssign('docNo', $event)"
      ></docNo-help-list>
    </v-dialog>

    <v-dialog v-model="showFundHelpList" width="900px" persistent>
      <fund-help-list @close="showFundHelpList = false" @assign-fund="doAssign('fund', $event)"></fund-help-list>
    </v-dialog>

    <v-dialog v-model="showAcctNoSfxHelpList" width="900px" persistent>
      <acct-suf-help-list @close="showAcctNoSfxHelpList = false" @assign-acct-suf="doAssign('acctNoSfx', $event)"></acct-suf-help-list>
    </v-dialog>

    <confirm v-model="promptRemove" @ok="doRemove">Are you sure you want to delete this record?</confirm>
  </page>
</template>
<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { commonMixins } from '@/mixins/common/commonMixin'
import { accountsAjaxCalls } from '@/mixins/accounting/accountsAjaxCalls'
import IntermediaryHelpList from '@/components/core/common/dialog/IntermediaryHelpList'
import BranchHelpList from '@/components/core/common/dialog/BranchHelpList'
import DocNoHelpList from '@/components/core/common/dialog/DocNoHelpList'
import FundHelpList from '@/components/core/common/dialog/FundHelpList'
import AcctSufHelpList from '@/components/core/common/dialog/AcctSufHelpList'

export default {
  data() {
    return {
      labels: {
        acctNo: 'Intermediary',
        branch: 'Branch',
        tranType: 'Transaction Type',
        docNo: 'Document No.',
        fund: 'Fund',
        acctNoSfx: 'Account No. Suffix',
        cancel: 'Cancel'
      },
      loading: false,
      headers: [
        { text: 'Inter No.', value: 'acctNo' },
        { text: 'Branch', value: 'branch' },
        { text: 'Type', value: 'tranType' },
        { text: 'Document No.', value: 'docNo' },
        { text: 'Fund', value: 'fund' },
        { text: 'Suffix', value: 'acctNoSfx' },
        TableConst.tableActionHeader
      ],
      form: {
        branch: null,
        tranType: null,
        docNo: null,
        acctNo: null,
        fund: null,
        acctNoSfx: null,
        tranType2: undefined
      },
      totalItems: 0,
      pagination: {
        sortBy: [],
        sortDesc: [false],
        page: 1
      },
      filters: {
        branch: null,
        tranType: null,
        docNo: null,
        acctNo: null,
        fund: null,
        acctNoSfx: null
      },
      selectedData: {},
      showInterHelpList: false,
      showTranTypeHelpList: false,
      showBranchHelpList: false,
      showDocNoHelpList: false,
      showFundHelpList: false,
      showAcctNoSfxHelpList: false,
      showAddRecord: false,
      fromFilters: false,
      fromForm: false,
      helpListFilterType: undefined,
      promptRemove: false
    }
  },
  methods: {
    async doInit() {
      this.loading = true
      await Promise.all([this.$store.dispatch('accountsInit')])
      await Promise.all([this.$store.dispatch('exclGsttranInit')])
      this.doFetch(true)
    },
    async doFetch(options) {
      const apiURI = this.menu.exlGsttranList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map(map => {
                const convertList = {
                  branch: map.branch,
                  tranType: map.tranType,
                  docNo: map.docNo,
                  acctNo: map.acctNo,
                  fund: map.fund,
                  acctNoSfx: map.acctNoSfx,
                  tranType2: map.tranType2
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doAdd() {
      this.doReset()
      this.showAddRecord = true
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doFetch(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.branch = null
      this.filters.tranType = null
      this.filters.docNo = null
      this.filters.acctNo = null
      this.filters.fund = null
      this.filters.acctNoSfx = null
      this.doFetch(false)
    },
    doCancel() {
      this.$router.push({ name: 'specFuncAcct' }).catch(() => {})
    },
    doReset() {
      this.resetMessages()
      this.form.branch = null
      this.form.tranType = null
      this.form.docNo = null
      this.form.acctNo = null
      this.form.fund = null
      this.form.acctNoSfx = null
    },
    doHelpList(actionName, fieldName) {
      this.helpListFilterType = actionName
      if (actionName === 'filters') {
        this.fromFilters = true
        this.fromForm = false
      } else {
        this.fromFilters = false
        this.fromForm = true
      }
      switch (fieldName) {
        case 'inter':
          this.showInterHelpList = true
          break
        case 'branch':
          this.showBranchHelpList = true
          break
        case 'docNo':
          this.showDocNoHelpList = true
          break
        case 'fund':
          this.showFundHelpList = true
          break
        case 'tranType':
          this.showTranTypeHelpList = true
          break
        case 'acctNoSfx':
          this.showAcctNoSfxHelpList = true
          break
      }
    },
    doAssign(fieldName, obj) {
      this.resetMessages()
      switch (fieldName) {
        case 'inter':
          if (this.fromFilters) {
            this.filters.acctNo = obj
          } else {
            this.form.acctNo = obj
          }
          break
        case 'branch':
          if (this.fromFilters) {
            this.filters.branch = obj
          } else {
            this.form.branch = obj
          }
          break
        case 'docNo':
          if (this.fromFilters) {
            this.filters.docNo = obj.docNo
          } else {
            this.form.docNo = obj.docNo
            this.form.branch = obj.branch
            this.form.tranType = obj.tranType
            this.form.fund = obj.fund
            this.form.acctNoSfx = obj.acctNoSfx
          }
          break
        case 'fund':
          if (this.fromFilters) {
            this.filters.fund = obj
          } else {
            this.form.fund = obj
          }
          break
        case 'tranType':
          if (this.fromFilters) {
            this.filters.tranType = obj
          } else {
            this.form.tranType = obj
          }
          break
        case 'acctNoSfx':
          if (this.fromFilters) {
            this.filters.acctNoSfx = obj
          } else {
            this.form.acctNoSfx = obj
          }
          break
      }
      this.fromFilters = false
      this.fromForm = false
    },
    doSave() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doCreate()
        }
      })
    },
    async doCreate() {
      this.resetMessages()
      const apiURI = this.menu.createExclGsttran
      if (apiURI) {
        this.loading = true
        try {
          const expand = this.form
          const result = await this.$http.post(apiURI, expand)
          const { data } = result
          if (data) {
            this.notify(data)
            this.fieldMessage(data)
          }
          this.loading = false
          this.doFetch(true)
          this.showAddRecord = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.notify(data)
          }
          this.loading = false
        }
      }
    },
    doPromptRemove(data) {
      this.selectedData = data
      this.promptRemove = true
    },
    async doRemove() {
      const apiURI = this.menu.deleteExclGsttran
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.post(apiURI, this.selectedData)
          const data = result.data
          this.doFetch(true)
          this.notify(data)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    branchValidation() {
      if (
        (this.form.tranType === null && this.form.docNo === null && this.form.fund === null && this.form.acctNoSfx === null) ||
        (this.form.tranType === undefined && this.form.docNo === undefined && this.form.fund === undefined && this.form.acctNoSfx === undefined) ||
        (this.form.tranType === '' && this.form.docNo === '' && this.form.fund === '' && this.form.acctNoSfx === '')
      ) {
        return ''
      } else {
        return 'required'
      }
    },
    tranTypeValidation() {
      if (
        (this.form.branch === null && this.form.docNo === null && this.form.fund === null && this.form.acctNoSfx === null) ||
        (this.form.branch === undefined && this.form.docNo === undefined && this.form.fund === undefined && this.form.acctNoSfx === undefined) ||
        (this.form.branch === '' && this.form.docNo === '' && this.form.fund === '' && this.form.acctNoSfx === '')
      ) {
        return ''
      } else {
        return 'required'
      }
    },
    docNoValidation() {
      if (
        (this.form.branch === null && this.form.tranType === null && this.form.fund === null && this.form.acctNoSfx === null) ||
        (this.form.branch === undefined && this.form.tranType === undefined && this.form.fund === undefined && this.form.acctNoSfx === undefined) ||
        (this.form.branch === '' && this.form.tranType === '' && this.form.fund === '' && this.form.acctNoSfx === '')
      ) {
        return ''
      } else {
        return 'required'
      }
    },
    fundValidation() {
      if (
        (this.form.branch === null && this.form.tranType === null && this.form.docNo === null && this.form.acctNoSfx === null) ||
        (this.form.branch === undefined && this.form.tranType === undefined && this.form.docNo === undefined && this.form.acctNoSfx === undefined) ||
        (this.form.branch === '' && this.form.tranType === '' && this.form.docNo === '' && this.form.acctNoSfx === '')
      ) {
        return ''
      } else {
        return 'required'
      }
    },
    acctNoSfxValidation() {
      if (
        (this.form.branch === null && this.form.tranType === null && this.form.docNo === null && this.form.fund === null) ||
        (this.form.branch === undefined && this.form.tranType === undefined && this.form.docNo === undefined && this.form.fund === undefined) ||
        (this.form.branch === '' && this.form.tranType === '' && this.form.docNo === '' && this.form.fund === '')
      ) {
        return ''
      } else {
        return 'required'
      }
    }
  },
  created() {
    this.doInit()
  },
  computed: {
    menu() {
      return this.$store.state.specFuncAcct.exclGsttran.menu
    }
  },
  watch: {
    pagination: function(value) {
      this.doFetch(true)
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin, commonMixins, accountsAjaxCalls],
  components: {
    BranchHelpList,
    IntermediaryHelpList,
    DocNoHelpList,
    FundHelpList,
    AcctSufHelpList
  }
}
</script>
<style lang="scss"></style>
